
const COS = require('cos-js-sdk-v5')
// 填写自己腾讯云cos中的key和id (密钥)
const cos = new COS({
  SecretId: 'AKIDR9kAXpyEZxaD52z2782kyJYeYP8qMmfW', // 身份识别ID
  SecretKey: '0ynU4d3NgrplXJua7lVBiFg4ZAlHdq1Q' // 身份秘钥
})
export function uploadTX(file) {
	var timetamp = new Date().getTime();
	let name = 'mipu/'+ formatDate(timetamp,false) + random_string(5)+'.jpg';
	// 执行上传操作
	return new Promise((resolve,reject) => { 
		cos.putObject({
			Bucket: 'yrkj-1321081330', /* 存储桶 */
			Region: 'ap-shanghai', /* 存储桶所在地域，必须字段 */
			Key: name, /* 文件名 */
			StorageClass: 'STANDARD', // 上传模式, 标准模式
			Body: file // 上传文件对象
		  }, (err, data) => {
			console.log(err || data)
			// 上传成功之后
			if (data.statusCode === 200) {
				return resolve('https://'+data.Location)
			}
		 })
	})
    

	
}
// 生成随机数
function random_string(len) {
	len = len || 32;
	var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
	var maxPos = chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}
// 返回时间日期
function formatDate(value,boolean) {
	let date = new Date(value);
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	if(boolean){
		return y + '/' + MM + '/' + d
	}else{
	  return y + '/' + MM + '/' + d + '/' + h + '' + m + '' + s;
	}
}